import actions from './actions';

const {
  GET_COMPARE_VEHICLE_BEGIN,
  GET_COMPARE_VEHICLE_SUCCESS,
  GET_COMPARE_VEHICLE_FAILED,
  ADD_COMPARE_VEHICLE_BEGIN,
  ADD_COMPARE_VEHICLE_SUCCESS,
  ADD_COMPARE_VEHICLE_FAILED,
  UPDATE_COMPARE_VEHICLE_BEGIN,
  UPDATE_COMPARE_VEHICLE_SUCCESS,
  UPDATE_COMPARE_VEHICLE_FAILED,
  DELETE_COMPARE_VEHICLE_BEGIN,
  DELETE_COMPARE_VEHICLE_SUCCESS,
  DELETE_COMPARE_VEHICLE_FAILED,
  GET_USER_COMPARE_VEHICLE_BEGIN,
  GET_USER_COMPARE_VEHICLE_SUCCESS,
  GET_USER_COMPARE_VEHICLE_FAILED,
} = actions;

const initState = {
  total: 0,
  currentPage: 1,
  pageLimit: 50,
  vehicles: [],
  compareVehiclesByUser: [],
  loading: false,
  error: null,
};

const CompareVehicleReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_COMPARE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_COMPARE_VEHICLE_SUCCESS:
      return {
        ...state,
        total: data.total,
        vehicles: data.compareVehicles,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_COMPARE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_COMPARE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_COMPARE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicles: data,
        total: state.total + 1,
        loading: false,
      };
    case ADD_COMPARE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_COMPARE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_COMPARE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicles: data,
        loading: false,
      };
    case UPDATE_COMPARE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_COMPARE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_COMPARE_VEHICLE_SUCCESS:
      return {
        ...state,
        vehicles: data,
        total: state.total - 1,
        loading: false,
      };
    case DELETE_COMPARE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case GET_USER_COMPARE_VEHICLE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_USER_COMPARE_VEHICLE_SUCCESS:
      return {
        ...state,
        total: data.total,
        compareVehiclesByUser: data.vehicles,
        currentPage: data.currentPage || 1,
        pageLimit: data.pageLimit || state.pageLimit,
        loading: false,
      };
    case GET_USER_COMPARE_VEHICLE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default CompareVehicleReducer;
